// src/App.js

import React from "react";
import GetRoastData from "./GetRoastData";

function App() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <GetRoastData />
    </div>
  );
}

export default App;
